/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Optin_LabelInputs */



/**
* | output |
* | --- |
* | "Send me product updates and news about oneAI" |
*
* @param {Newsletter_Optin_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_label = /** @type {((inputs?: Newsletter_Optin_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Produkt-Updates und Neuigkeiten zu oneAI erhalten")
	return /** @type {LocalizedString} */ ("Send me product updates and news about oneAI")
});